/* import __COLOCATED_TEMPLATE__ from './subsection.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';

export interface BvCardSubsectionSignature {
  Blocks: {
    default: [];
  };
  Element: HTMLDivElement;
}

const BvCardSubsectionComponent = templateOnlyComponent<BvCardSubsectionSignature>();

export default BvCardSubsectionComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'BvCard::Subsection': typeof BvCardSubsectionComponent;
    'bv-card/subsection': typeof BvCardSubsectionComponent;
  }
}
